var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpwardExpandIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51333 0.692142C8.74862 -0.206381 7.36946 -0.231375 6.5727 0.638848L0.144062 7.66021C-0.0571682 7.87999 -0.0446562 8.22062 0.172157 8.42505C0.394923 8.63509 0.746928 8.62056 0.951621 8.39287L6.56738 2.1462C7.36328 1.26089 8.75789 1.28285 9.52551 2.1928L14.765 8.40372C14.9744 8.65196 15.3614 8.63739 15.5515 8.3741C15.6862 8.18762 15.676 7.93328 15.527 7.75811L9.51333 0.692142Z",
    fill: "#5AC69F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardExpandIcon);
export default __webpack_public_path__ + "static/media/upward-expand-icon.cbc01e3d303bad6e4d4496824a3d44b1.svg";
export { ForwardRef as ReactComponent };